// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nfooter[data-v-28f620fa]\n{\n\tmargin-top: auto;\n\tpadding: 10px;\n\twidth: 100%;\n\ttext-align: center;\n\tbox-sizing: border-box;\n\t/*background-color: rgba(255,255,255,0.25);*/\n\t/*box-shadow: 0 0 16px rgba(0,0,0,0.25);*/\n\tborder-top: 1px solid rgba(0,0,0,0.25);\n}\n", ""]);
// Exports
module.exports = exports;
